import { create } from 'zustand';

/**
 * Zustand store for Recovery Activities
 * Manages the step-by-step recovery plan for crisis events
 */
export const useRecoveryActivitiesStore = create((set, get) => ({
    // State
    activities: [],
    loading: false,
    error: null,

    // Actions
    setActivities: (activities) => set({ activities }),

    addActivity: (activity) => {
        const current = get().activities;
        const newItem = {
            ...activity,
            id: activity.id || Date.now(),
            progress: activity.progress || 0
        };
        // Sort by step number
        const newActivities = [...current, newItem].sort((a, b) => a.step - b.step);
        set({ activities: newActivities });
        return newItem;
    },

    updateActivity: (updatedActivity) => {
        const current = get().activities;
        const newActivities = current
            .map(a => a.id === updatedActivity.id ? updatedActivity : a)
            .sort((a, b) => a.step - b.step);
        set({ activities: newActivities });
        return updatedActivity;
    },

    deleteActivity: (id) => {
        const current = get().activities;
        set({ activities: current.filter(a => a.id !== id) });
    },

    reorderActivities: (startIndex, endIndex) => {
        const current = [...get().activities];
        const [removed] = current.splice(startIndex, 1);
        current.splice(endIndex, 0, removed);

        // Update step numbers based on new order
        const reordered = current.map((activity, index) => ({
            ...activity,
            step: index + 1
        }));
        set({ activities: reordered });
    },

    // Initialize from crisis object
    initializeFromCrisis: (crisis) => {
        if (crisis?.recoveryActivities) {
            set({ activities: crisis.recoveryActivities.sort((a, b) => a.step - b.step) });
        } else {
            set({ activities: [] });
        }
    },

    clearStore: () => set({ activities: [], error: null })
}));
